<template lang="pug">
.equipment-tech-map
  .tech-map-card
    .main-block
      qr-image(:url="qrObject.url")

      .actions-block
        .tech-map-title
          .title
            span {{ data.title }}
          .sub-title
            span {{ data.sub_title }}

    .specification-block
      .block-title
        span {{ titles.specification }}

      div
        table.specification-table
          tbody
            tr(v-for="item in getSpecificationData()", :key="item.id || item.label")
              td {{ item.label }}
              td(v-if="item.type === 'attachments'")
                a.field-value-attachment(
                  v-for="attachment in getAttachments(item)",
                  :key="`${attachment.file_name} ${attachment.file_size}`",
                  target="_blank",
                  :href="attachment.url"
                ) {{ attachment.file_name }}
              td(v-else-if="item.type === 'link'")
                a(v-if="item.value", :href="item.value", target="_blank") {{ item.value }}
              td(v-else-if="item.type === 'list'")
                div(v-for="(listItem, index) in getListValue(item)", :key="`${listItem} ${index}`") {{ listItem }}
              td(v-else) {{ getSpecificationValue(item) }}

    .components-block
      .block-title
        span {{ titles.components }}

      table#print-components-table.tech-map-tab-table.components-table
        thead
          tr
            th(v-for="column in data['columns']['components']", :key="column.name")
              span.column-header-title {{ column.label }}
        tbody
          tr(v-for="item in getData('components')")
            td(
              v-for="key in Object.keys(item)",
              :class="key === 'properties' ? 'properties-td td-' + key : 'td-' + key",
              :style="{ padding: key === 'properties' ? '0' : '10px' }"
            )
              table.properties-table(v-if="key === 'properties'")
                tr(v-for="sub_item in item[key]")
                  td(v-for="sub_key in Object.keys(sub_item)")
                    span {{ sub_item[sub_key].length > 0 ? sub_item[sub_key] : "-" }}

              span(v-else) {{ item[key].length > 0 ? item[key] : "-" }}

    .replaced-components-block
      .block-title
        span {{ titles.replaced_components }}

      table#print-replaced-components-table.tech-map-tab-table.replaced-components-table
        thead
          tr
            th(v-for="column in data['columns']['replaced_components']", :key="column.name")
              span.column-header-title {{ column.label }}
        tbody
          tr(v-for="item in getData('replaced_components')")
            td(
              v-for="key in Object.keys(item)",
              :class="key === 'properties' ? 'properties-td td-' + key : 'td-' + key",
              :style="{ padding: key === 'properties' ? '0' : '10px' }"
            )
              table.properties-table(v-if="key === 'properties'")
                tr(v-for="sub_item in item[key]")
                  td(v-for="sub_key in Object.keys(sub_item)")
                    span {{ sub_item[sub_key].length > 0 ? sub_item[sub_key] : "-" }}

              span(v-else) {{ item[key].length > 0 ? item[key] : "-" }}

    .issues-block(v-if="getData('issues').length > 0")
      .block-title
        span {{ titles.issues }}

      table.tech-map-tab-table.issues-table
        thead
          tr
            th(v-for="column in data['columns']['issues']", :key="column.name")
              span.column-header-title {{ column.label }}
        tbody
          tr(v-for="issue_data in getData('issues')", :key="issue_data.id")
            td(
              v-for="td in getIssueRows(issue_data)",
              :key="getIssueTdKey(issue_data, td)",
              :class="td.key",
              :style="td.style"
            )
              span {{ formatIssueValue(td.value) }}
</template>

<script>
import qrImage from "../../../../../../shared/print/qrImage";
import { formatDateText } from "@/services/useDateTextFormatter";

export default {
  components: {
    qrImage,
  },

  props: {
    parentData: {
      type: Object,
      default: () => {},
    },
  },

  data: function () {
    return {
      data: this.parentData.data,
      titles: this.parentData.titles,
      row: this.parentData.row,
    };
  },

  computed: {
    qrObject() {
      return this.data.qr;
    },
  },

  methods: {
    getData(key) {
      if (key) {
        if (key === "issues") {
          return this.row[key] || [];
        } else {
          return this.row["technological_map"][key];
        }
      }
    },

    getSpecificationData() {
      return this.getData("specification") || [];
    },

    getAttachments(item) {
      return Array.isArray(item.value) ? item.value : [];
    },

    getListValue(item) {
      return Array.isArray(item.value) ? item.value : [];
    },

    getSpecificationValue(item) {
      if (item.type === "date") {
        return formatDateText(item.value) || "";
      }

      if (Array.isArray(item.value)) {
        return item.value.join(", ");
      }

      return item.value ?? "";
    },

    getIssueRows(issue) {
      return Array.isArray(issue.rows) ? issue.rows : [];
    },

    getIssueTdKey(issue, td) {
      return `${issue.id}_${td.key}`;
    },

    formatIssueValue(value) {
      return formatDateText(value, "dd.MM.yyyy, HH:mm");
    },
  },
};
</script>
